import { render, staticRenderFns } from "./AppointmentFlow.vue?vue&type=template&id=2cdb45af&scoped=true"
import script from "./AppointmentFlow.vue?vue&type=script&lang=js"
export * from "./AppointmentFlow.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFlow.vue?vue&type=style&index=0&id=2cdb45af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb45af",
  null
  
)

export default component.exports